
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';

const SalonByCategory = () => {
    const { categoryId, categoryName } = useParams();
    const [salons, setSalons] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const THEME_COLOR = '#065f46';

    useEffect(() => {
        window.scrollTo(0, 0);
        loadSalonsByServiceName();
    }, [categoryName]);

    const loadSalonsByServiceName = async () => {
        setLoading(true);
        try {
            const [salonRes, serviceRes] = await Promise.all([
                axios.get(`${config.APIACTIVEURL}${config.GETALLSALON}`),
                axios.get(`${config.APIACTIVEURL}${config.GETSERVICETYPE}`)
            ]);

            const allSalons = salonRes.data || [];
            const allServices = serviceRes.data?.data || serviceRes.data?.items || serviceRes.data || [];

            const matchedServices = allServices.filter(service => {
                const searchLower = categoryName.toLowerCase();
                const serviceName = (service.name || "").toLowerCase();
                const serviceCategory = (service.category || "").toLowerCase();
                return serviceName.includes(searchLower) || serviceCategory === searchLower;
            });

            const validSalonIds = [...new Set(matchedServices.map(s => s.salonId))];
            const filtered = allSalons.filter(s => validSalonIds.includes(s.salonId));
            
            setSalons(filtered);
        } catch (error) {
            console.error("Error filtering salons", error);
        } finally {
            setLoading(false);
        }
    };

    const handleBookAppointment = (e, salonId) => {
        e.stopPropagation(); 
        // Points to your CustomerLayout route
        navigate(`/book-service?salonId=${salonId}`); 
    };

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px' }}>
            <div className="container py-5">
                <div className="mb-5">
                    <Link to="/" className="text-decoration-none fw-bold" style={{ color: THEME_COLOR }}>
                        <i className="ri-arrow-left-line"></i> Back to Home
                    </Link>
                    <h1 className="display-6 fw-bold mt-2" style={{ color: '#064e3b' }}>
                        Salons offering "{categoryName}"
                    </h1>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border" style={{ color: THEME_COLOR }}></div>
                    </div>
                ) : (
                    <div className="row g-4">
                        {salons.length > 0 ? salons.map(salon => (
                            <div className="col-md-6 col-lg-4" key={salon.salonId}>
                                <div 
                                    className="card border-0 shadow-sm h-100" 
                                    style={{ borderRadius: '1.5rem', cursor: 'pointer' }}
                                    onClick={() => navigate(`/salon-details/${salon.salonId}`)}
                                >
                                    <img 
                                        src="/assets/salonimage.jpg" 
                                        className="card-img-top" 
                                        style={{ height: '220px', objectFit: 'cover', borderRadius: '1.5rem 1.5rem 0 0' }} 
                                        alt="Salon Thumbnail" 
                                        onError={(e) => { e.target.src = 'https://via.placeholder.com/400x250?text=Salon'; }}
                                    />
                                    
                                    <div className="card-body p-4">
                                        <h5 className="fw-bold mb-1">{salon.name || salon.salonName}</h5>
                                        <p className="text-muted small mb-3">
                                            <i className="ri-map-pin-line"></i> {salon.address || 'Address not listed'}
                                        </p>
                                        <button 
                                            className="btn w-100 rounded-pill fw-bold" 
                                            style={{ border: `1px solid ${THEME_COLOR}`, color: THEME_COLOR }}
                                            onClick={(e) => handleBookAppointment(e, salon.salonId)}
                                        >
                                            Book Appointment
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <div className="text-center py-5 w-100">
                                <h4 className="text-muted">No salons found for "{categoryName}".</h4>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SalonByCategory;